export type AutoFocusTarget = 'dialog' | 'first-tabbable' | 'first-heading';

export class SideDialogOptions {
  width?: string | number;
  panelClass?: string | string[];
  data?: any;
  disableClose?: boolean;
  autoFocus?: AutoFocusTarget | string | boolean;
  templateContext?: Record<string, any> | (() => Record<string, any>);
}
